import React, { useState, useEffect, useCallback } from "react";
import SalvareDate from "../../SalvareDate";
import ButonIstoric from "../../ButonIstoric";
import {
  getStorage,
  ref,
  listAll,
  getDownloadURL,
  deleteObject,
  uploadBytes,
} from "firebase/storage";
import "../../stiluri/DatePersonale.css";
import { getFirestore, doc, getDoc } from "firebase/firestore";


const DatePersonale = ({ beneficiar, setBeneficiar, setEditMode, utilizator , id}) => {
  const [localBeneficiar, setLocalBeneficiar] = useState(beneficiar);
  const storage = getStorage();
  const rootPath = `${id}/documente_de_identitate/`;
  const [tree, setTree] = useState(null);
  const [expandedPaths, setExpandedPaths] = useState(new Set([rootPath]));
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(rootPath);
  const numeComponenta = "DatePersonale";
    const db = getFirestore();

const campuriSalvate = [ "nume",
  "prenume",
  "cnp",
  "serienrci",
  "data_nasterii",
  "datadeces",
  "birthPlace",
  "StradaNumar",
  "OrasComunaSat",
  "JudetSector",
  "Tara",
  "Cetatenie",
  "starecivila",
  "Profesie",
  "Studii",
  "Religie",
  "OrientareSexuala",
  "Sex",
  "IdentitateDeGen",
  "DiagnosticMedical",
  "StatusHIV",
  "StatusTBC",
  "ConsumAlcool",
  "ConsumDroguri",
  "StareAutonomie",
  "AcceptaAsistenta",
  "ComportamentAgresiv",
  "telefon",
  "email"];


  // Fetch datele beneficiarului din Firestore la mount și când id se schimbă
  useEffect(() => {
    if (!id) return;
    const fetchBeneficiar = async () => {
      try {
        const docRef = doc(db, "Beneficiari", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setLocalBeneficiar(docSnap.data());
        } else {
          setError("Beneficiarul nu a fost găsit.");
        }
      } catch (err) {
        setError("Eroare la încărcarea beneficiarului.");
        console.error(err);
      }
    };

    fetchBeneficiar();
  }, [db, id]);




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLocalBeneficiar((prev) => ({ ...prev, [name]: value }));
  };


  // Încarcă doar structura folderelor, fără URL-uri
  const loadFolderStructure = useCallback(async (path) => {
  try {
    const folderRef = ref(storage, path);
    const res = await listAll(folderRef);

    // Nu mai încărcăm folderele din subfoldere la start
    const folders = res.prefixes.map((folderRef) => ({
      name: folderRef.name,
      path: folderRef.fullPath,
      folders: [],
      files: [],
    }));

    const files = res.items.map((itemRef) => ({
      name: itemRef.name,
      fullPath: itemRef.fullPath,
      url: null,
    }));

    return {
      name: path.split("/").filter(Boolean).pop() || "root",
      path,
      folders,
      files,
    };
  } catch (err) {
    console.error(err);
    return null;
  }
}, [storage]);

  // Lazy load pentru fișierele din folder
  const loadFilesForNode = async (node) => {
    const folderRef = ref(storage, node.path);
    const res = await listAll(folderRef);
    const files = await Promise.all(
      res.items.map(async (itemRef) => ({
        name: itemRef.name,
        fullPath: itemRef.fullPath,
        url: null, // lazy
      }))
    );
    return files;
  };

const expandNode = async (path, currentNode) => {
  setExpandedPaths((prev) => new Set(prev).add(path));

  if (currentNode && currentNode.files.length === 0 && currentNode.folders.length === 0) {
    // Încarcă folderele (subfoldere)
    const folderRef = ref(storage, path);
    const res = await listAll(folderRef);

    // Folderele din folderul curent
    const folders = res.prefixes.map((folderRef) => ({
      name: folderRef.name,
      path: folderRef.fullPath,
      folders: [],
      files: [],
    }));

    // Folosim funcția ta pentru a încărca fișierele (lazy loading)
    const files = await loadFilesForNode(currentNode);

    // Actualizăm arborele cu folderele și fișierele
    const updateTree = (node) => {
      if (node.path === path) {
        return { ...node, folders, files };
      }
      return {
        ...node,
        folders: node.folders.map(updateTree),
      };
    };

    setTree((prevTree) => updateTree(prevTree));
  }
};

const handlePreview = async (file) => {
  if (!file.url) {
    const url = await getDownloadURL(ref(storage, file.fullPath));

    // Actualizează URL-ul în arbore (cache)
    const updateFileUrl = (node) => {
      if (!node) return node;
      return {
        ...node,
        files: node.files.map(f => 
          f.fullPath === file.fullPath ? { ...f, url } : f
        ),
        folders: node.folders.map(updateFileUrl),
      };
    };

    setTree(prevTree => updateFileUrl(prevTree));
    setPreview({ ...file, url });
  } else {
    setPreview(file);
  }
};

  useEffect(() => {
    if (!id) {
      setError("ID-ul beneficiarului nu este definit.");
      return;
    }

    setLoading(true);
    loadFolderStructure(rootPath)
      .then((data) => {
        setTree(data);
        setSelectedFolder(rootPath);
        setLoading(false);
        setError(null);
      })
      .catch(() => {
        setError("Eroare la încărcarea galeriei.");
        setLoading(false);
      });
  }, [id, loadFolderStructure, rootPath]);

  const toggleExpand = async (path, node) => {
    if (expandedPaths.has(path)) {
      setExpandedPaths((prev) => {
        const newSet = new Set(prev);
        newSet.delete(path);
        return newSet;
      });
    } else {
      await expandNode(path, node);
    }
  };

  const handleDeleteFile = async (file) => {
    if (window.confirm(`Ștergi fișierul "${file.name}"?`)) {
      try {
        const fileRef = ref(storage, file.fullPath);
        await deleteObject(fileRef);
        alert("Fișier șters cu succes!");
await expandNode(file.fullPath.substring(0, file.fullPath.lastIndexOf('/')), tree);

        setPreview(null);
      } catch (err) {
        alert("Eroare la ștergerea fișierului.");
        console.error(err);
      }
    }
  };

  const getAllFolders = (node) => {
    if (!node) return [];
    let foldersList = [{ name: node.name, path: node.path }];
    node.folders.forEach((folder) => {
      foldersList = foldersList.concat(getAllFolders(folder));
    });
    return foldersList;
  };

 const handleUploadSubmit = async (e) => {
    e.preventDefault();
    if (selectedFiles.length === 0) {
      alert("Alege cel puțin un fișier!");
      return;
    }
    setUploading(true);
    try {
      const pathWithSlash = selectedFolder.endsWith('/')
        ? selectedFolder
        : selectedFolder + '/';

      // Încarcă fișierele una câte una în paralel (sau poți face în serie)
      await Promise.all(
        selectedFiles.map((file) => {
          const fileRef = ref(storage, pathWithSlash + file.name);
          return uploadBytes(fileRef, file);
        })
      );

      alert("Încărcare reușită!");
      await expandNode(selectedFolder, tree);

      setSelectedFiles([]);
      setShowUploadModal(false);
    } catch (err) {
      alert("Eroare la upload.");
      console.error(err);
    }
    setUploading(false);
  };

  const handleDragOver = (e) => {
  e.preventDefault();
  e.stopPropagation();
};

const handleDrop = (e) => {
  e.preventDefault();
  e.stopPropagation();
  const files = Array.from(e.dataTransfer.files);
  if (files.length > 0) {
    setSelectedFiles((prev) => [...prev, ...files]);
  }
};


  const renderNode = (node) => {
    if (!node) return null;

    const isExpanded = expandedPaths.has(node.path);

    return (
      <div className="folder" key={node.path}>
        <div
          className="folder-name"
          onClick={() => toggleExpand(node.path, node)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter") toggleExpand(node.path, node);
          }}
        >
          {isExpanded ? "📂" : "📁"} {node.name}
        </div>

        {isExpanded && (
          <div className="folder-contents">
            {node.folders.map((folder) => renderNode(folder))}
            {node.files.map((file) => (
              <div className="file" key={file.fullPath}>
                <span
                  className="file-name"
                  onClick={() => handlePreview(file)}
                  role="button"
                  tabIndex={0}
                >
                  📄 {file.name}
                </span>
                <button
                  className="preview-btn"
                  onClick={() => handlePreview(file)}
                  title="Previzualizează"
                >
                  👁️
                </button>
                <a
                  href={file.url || "#"}
                  onClick={(e) => {
                    if (!file.url) e.preventDefault();
                  }}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-link"
                >
                  ⬇️
                </a>
                <button
                  className="delete-btn"
                  onClick={() => handleDeleteFile(file)}
                  title="Șterge"
                >
                  ❌
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };


  return (
    <div className="row g-4">
  {/* COL STÂNGA: PRIMA JUMĂTATE DATE PERSONALE */}
  <div className="col-md-6">
    <div className="card shadow-sm">
      <div className="card-header bg-primary text-white">Date personale</div>
      <div className="card-body">
        {[
          { label: "Nume", name: "nume" },
          { label: "Prenume", name: "prenume" },
          { label: "CNP", name: "cnp" },
          { label: "Serie/Nr CI", name: "serienrci" },
          { label: "Data nașterii", name: "data_nasterii", type: "date" },
          { label: "Data Decesului", name: "datadeces", type: "date"  },
          { label: "Loc de naștere", name: "birthPlace" },
          { label: "Strada, Nr", name: "StradaNumar" },
          { label: "Oraș/Comună/Sat", name: "OrasComunaSat" },
          { label: "Judet/Sector", name: "JudetSector" },
          { label: "Țară", name: "Tara" },
          { label: "Cetățenie", name: "Cetatenie" },
            { label: "Stare civilă", name: "starecivila" },

        ].map(({ label, name, type = "text" }) => (
          <div className="mb-3" key={name}>
            <label className="form-label">{label}</label>
            <input
              type={type}
              name={name}
              className="form-control"
              value={localBeneficiar[name] || ""}
              onChange={handleInputChange}
            />
          </div>
          
        ))}
        {/* Salvare date aici (poate fi și sub ambele coloane dacă vrei) */}
<SalvareDate
 beneficiar={localBeneficiar}  id={id}
  numeComponenta={numeComponenta}
  campuriSalvate={campuriSalvate}
/>



      </div>
      
    </div>

  </div>

  {/* COL DREAPTA: RESTUL DATE + DOCUMENTE */}
  <div className="col-md-6">
    <div className="card shadow-sm mb-4">
      <div className="card-header bg-primary text-white">Date personale</div>
      <div className="card-body">
        {[
  { label: "Profesie", name: "Profesie" },
  { label: "Studii", name: "Studii" },
  { label: "Religie", name: "Religie" },
  { label: "Orientare Sexuală", name: "OrientareSexuala" },
  { label: "Sex", name: "Sex" },
  { label: "Identitate de gen", name: "IdentitateDeGen" },
  { label: "Diagnostic Medical", name: "DiagnosticMedical" },
  { label: "Status HIV", name: "StatusHIV" },
  { label: "Status TBC", name: "StatusTBC" },
  { label: "Consum Alcool", name: "ConsumAlcool" },
  { label: "Consum Droguri", name: "ConsumDroguri" },
  { label: "Stare Autonomie", name: "StareAutonomie" },
  { label: "Acceptă Asistență", name: "AcceptaAsistenta" },
  { label: "Comportament Agresiv", name: "ComportamentAgresiv" },
].map(({ label, name }) => {
  const dropdownOptions = {
    StatusHIV: ["Negativ", "Pozitiv", "Necunoscut"],
    StatusTBC: ["Negativ", "Pozitiv", "Necunoscut"],
    ConsumAlcool: ["Frecvent", "Ocazional", "Deloc", "Fost consumator"],
    ConsumDroguri: ["Frecvent", "Ocazional", "Deloc", "Fost consumator"],
    StareAutonomie: ["Completă", "Parțială", "Dependent"],
    AcceptaAsistenta: ["Da", "Nu", "Ocazional"],
    ComportamentAgresiv: ["Da", "Nu", "Imprevizibil", "Ocazional"],
  };

  const isDropdown = Object.keys(dropdownOptions).includes(name);


  if (!localBeneficiar) return <p>Se încarcă datele beneficiarului...</p>;




  return (
    <div className="mb-3" key={name}>
      <label className="form-label">{label}</label>
      {isDropdown ? (
        <select
          className="form-control"
          name={name}
          value={localBeneficiar[name] || ""}
          onChange={handleInputChange}
        >
          <option value="">Selectează</option>
          {dropdownOptions[name].map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      ) : (
        <input
          type="text"
          name={name}
          className="form-control"
          value={localBeneficiar[name] || ""}
          onChange={handleInputChange}
        />
      )}
    </div>
  );
})}

        
      </div>
      
    </div>

   
  </div>
  
  <div className="documente-card-modern">
  <h2 className="documente-titlu">📎 Documente de identitate</h2>
  {loading && <p>Se încarcă galeria...</p>}
  {error && <p className="error-msg">{error}</p>}
  {tree ? renderNode(tree) : <p>Te rugăm să aștepți.</p>}

  {preview && (
    <div className="preview-overlay" onClick={() => setPreview(null)}>
      <div
        className="preview-content"
        onClick={(e) => e.stopPropagation()}
        tabIndex={-1}
      >
        <button className="close-btn" onClick={() => setPreview(null)}>
          ×
        </button>
        <h3>{preview.name}</h3>
        {preview.url ? (
          <>
            {preview.name.match(/\.(jpg|jpeg|png|gif)$/i) ? (
              <img
                src={preview.url}
                alt={preview.name}
                className="preview-image"
              />
            ) : preview.name.match(/\.pdf$/i) ? (
              <iframe
                src={preview.url}
                title={preview.name}
                className="preview-pdf"
              />
            ) : (
              <p>Preview indisponibil.</p>
            )}
          </>
        ) : (
          <p>Se încarcă...</p>
        )}
      </div>
    </div>
  )}

  <button
    className="upload-btn"
    onClick={() => setShowUploadModal(true)}
    style={{ marginTop: "1rem" }}
  >
    Încarcă fișier
  </button>

  {showUploadModal && (
    <div
      className="modal-overlay"
      onClick={() => setShowUploadModal(false)}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        tabIndex={-1}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
      >
        <button className="close-btn" onClick={() => setShowUploadModal(false)}>
          ×
        </button>
        <h3>Încarcă fișier</h3>
        <p>Trage fișierele aici sau folosește selectorul de fișiere.</p>

        <form onSubmit={handleUploadSubmit}>
          <label htmlFor="folderSelect">Folder:</label>
          <select
            id="folderSelect"
            value={selectedFolder}
            onChange={(e) => setSelectedFolder(e.target.value)}
          >
            {tree &&
              getAllFolders(tree).map((folder) => (
                <option key={folder.path} value={folder.path}>
                  {folder.path}
                </option>
              ))}
          </select>

          <input
            type="file"
            multiple
            onChange={(e) => setSelectedFiles(Array.from(e.target.files))}
            required={selectedFiles.length === 0}
            disabled={uploading}
            style={{ marginTop: "1rem" }}
          />
          {selectedFiles.length > 0 && (
            <p>{selectedFiles.length} fișier(e) selectat(e)</p>
          )}
          <button type="submit" disabled={uploading}>
            {uploading ? "Se încarcă..." : "Încarcă"}
          </button>
        </form>
      </div>
    </div>
  )}
</div>

          <ButonIstoric id={id} numeComponenta={numeComponenta} />

</div>

  );
};

export default DatePersonale;
